export enum ProductModTargetType {
	/**
	 * 추가
	 */
  CLASSIFICATION = "CLASSIFICATION",

	/**
	 * 수정
	 */
  FEEDBACK = "FEEDBACK",
	
  /**
   * 사용자
   */
  USER = "USER",

}

export const ProductModTargetTypes = [
  {
    value: ProductModTargetType[ProductModTargetType.CLASSIFICATION],
    label: 'AI',
    status: 'primary',
  },
  {
    value: ProductModTargetType[ProductModTargetType.FEEDBACK],
    label: '피드백',
    status: 'warning',
  },
  {
    value: ProductModTargetType[ProductModTargetType.USER],
    label: '사용자',
    status: 'info',
  },
];
